module.exports = __webpack_public_path__ + "static/opis-inwestycji-d6a99cf21c40bfd4ae9694a0733a791b.jpg";